import { useQuery } from "@tanstack/react-query";
import { FlaskConical } from "lucide-react";
import { httpRequest } from "@/shared/api/http";
import { Button } from "@/shared/ui";

/**
 * DEV ONLY. Shows the one-time code the backend "sent" (no SMS provider in development).
 * Rendered only when the build sets VITE_SHOW_DEV_OTP=true; the backend endpoint exists only
 * with its `dev` profile and is deliberately absent from the generated API client.
 */
export function DevCodeHint({ phone, sentAt, onUse }: DevCodeHintProps) {
  const peek = useQuery({
    queryKey: ["dev-otp", phone, sentAt],
    queryFn: () =>
      httpRequest<{ lc_code: string }>("/api/dev/otp/peek", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lc_phone: phone }),
      }),
    retry: false,
    staleTime: Infinity,
  });

  if (!peek.data) return null;
  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-dashed border-amber-400 bg-amber-50 px-4 py-3 text-sm">
      <span className="flex items-center gap-2 text-amber-900">
        <FlaskConical className="size-4" aria-hidden />
        DEV · код: <b className="font-mono tracking-widest">{peek.data.lc_code}</b>
      </span>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        onClick={() => {
          onUse(peek.data.lc_code);
        }}
      >
        Подставить
      </Button>
    </div>
  );
}

interface DevCodeHintProps {
  phone: string;
  /** Changes on every (re)send, so a resent code is fetched again. */
  sentAt: string;
  onUse: (code: string) => void;
}
